import { executeCommand } from './../../../services/namespaces/utils'
import { ShellElement } from './../../../common/shell-element'
import type { GlobalSearchActionUI, GlobalSearchResultItem } from './../global-search-models'
import { GlobalSearchResultPreview } from './../global-search-models'
import { html, property } from 'lit-element'
import { nothing } from 'lit-html'
import { AvatarSize } from '../../../services/avatar/models'
import searchResultPreviewItem from './search-result-preview-item.styles.scss'
import { addToSearchHistory } from '../helpers'
import { unsafeSVG } from 'lit-html/directives/unsafe-svg'

export class SearchResultPreviewItem extends ShellElement {
  static readonly tagName = 'goto-search-result-preview-item'

  @property({ type: String }) searchString = ''
  @property({ type: Object }) searchResult: GlobalSearchResultPreview = {
    title: '',
    preview: '',
    userKey: '',
    icon: '',
    actions: [],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  }

  private shouldShowPresence() {
    return true
  }

  static get styles() {
    return searchResultPreviewItem
  }

  private renderPreviewActions() {
    return html` ${this.searchResult.actions.length
      ? html`<div class="search-result-preview-actions">
          <goto-global-search-actions
            .actions=${this.searchResult.actions}
            .originalResult=${this.searchResult.originalResult}
            searchString=${this.searchString}
          ></goto-global-search-actions>
        </div>`
      : nothing}`
  }

  private renderIconOrAvatar() {
    return html`${this.searchResult.userKey
      ? html`
          <goto-avatar
            .showPresence=${this.shouldShowPresence()}
            .externalUserKey=${this.searchResult.userKey}
            .familyName=${this.searchResult.familyName}
            .givenName=${this.searchResult.givenName}
            .size=${AvatarSize.MEDIUM}
            variant="primary"
          ></goto-avatar>
        `
      : html`
          <chameleon-avatar .size=${AvatarSize.MEDIUM} class="round-icon">
            <chameleon-svg>${unsafeSVG(this.searchResult.icon)}</chameleon-svg>
          </chameleon-avatar>
        `}`
  }
  //TODO: highlight searchString matches in the title https://jira.ops.expertcity.com/browse/SCORE-2268
  private renderTitle() {
    return html` <div class="search-result-title">
      <chameleon-typography line-clamp="1" variant="body-small-strong">
        ${this.searchResult.title}
      </chameleon-typography>
    </div>`
  }
  //TODO: highlight searchString matches in the preview https://jira.ops.expertcity.com/browse/SCORE-2268
  private renderPreview() {
    return html` <div class="search-result-preview">
      <chameleon-typography line-clamp="1" class="search-result-preview" variant="caption-medium"
        >${this.searchResult.preview}
      </chameleon-typography>
    </div>`
  }

  private executeDefaultActionCommand() {
    const params = [this.searchResult.originalResult, this.searchString]
    if (this.searchResult.defaultAction?.command) {
      executeCommand(this.searchResult.defaultAction?.command, [...params])
    }
  }

  render() {
    // TODO: handle a11y concerns when we create chameleon list component https://jira.ops.expertcity.com/browse/SCORE-2265
    // eslint-disable-next-line lit-a11y/click-events-have-key-events
    return html`<div
      tabindex="0"
      class="search-result-preview-item"
      @click="${() => {
        addToSearchHistory({ query: this.searchResult.title })
        this.executeDefaultActionCommand()
      }}"
    >
      <div class="search-result-preview-info">
        ${this.renderIconOrAvatar()}
        <div class="title-and-preview">${this.renderTitle()} ${this.renderPreview()}</div>
      </div>
      ${this.renderPreviewActions()}
    </div>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [SearchResultPreviewItem.tagName]: SearchResultPreviewItem
  }
}
